import styled from 'styled-components';
import { BasketUserDetailsStyled } from '../BasketUserDetailsStyled';
import { rem } from 'polished';

export const BasketUserDetailsDS = styled(BasketUserDetailsStyled)`
    border-color: ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }

    .description {
        span {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }

        .link {
            font-size: ${({ theme }) => theme.fontSizes.h5};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .form {
        border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey2};
    }

    .reinsurance {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .required-section p {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.grey1};
    }

    .input-section {
        &-title {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }

        input {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            height: ${rem(46)};
            border-radius: ${rem(4)};

            &.error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &-error {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }
`;
